module.exports = __webpack_public_path__ + "img/usuarios.1965f647.svg";